import appConfig from '../../config/appConfig';
import * as localizationKeys from '../../consts/localization/localizationKeys';
import {getLocalizedStrings} from '../../services/localization/localizationService';
import storageService from '../../services/storage/storageService';

const AGE_GATE_CONSTS = {
    MONTH_JANUARY_VALUE: 0,
    MONTH_FEBRUARY_VALUE: 1,
    MONTH_MARCH_VALUE: 2,
    MONTH_APRIL_VALUE: 3,
    MONTH_MAY_VALUE: 4,
    MONTH_JUNE_VALUE: 5,
    MONTH_JULY_VALUE: 6,
    MONTH_AUGUST_VALUE: 7,
    MONTH_SEPTEMBER_VALUE: 8,
    MONTH_OCTOBER_VALUE: 9,
    MONTH_NOVEMBER_VALUE: 10,
    MONTH_DECEMBER_VALUE: 11,
    YEAR_START_VALUE: 1920,
};

const getMonthsOptions = () => {
    const localizedStrings = getLocalizedStrings();

    return [
        {
            value: '',
            text: localizedStrings[localizationKeys.AGE_GATE_MONTH],
        },
        {
            value: AGE_GATE_CONSTS.MONTH_JANUARY_VALUE,
            text: localizedStrings[localizationKeys.AGE_GATE_JANUARY_TEXT],
        },
        {
            value: AGE_GATE_CONSTS.MONTH_FEBRUARY_VALUE,
            text: localizedStrings[localizationKeys.AGE_GATE_FEBRUARY_TEXT],
        },
        {
            value: AGE_GATE_CONSTS.MONTH_MARCH_VALUE,
            text: localizedStrings[localizationKeys.AGE_GATE_MARCH_TEXT],
        },
        {
            value: AGE_GATE_CONSTS.MONTH_APRIL_VALUE,
            text: localizedStrings[localizationKeys.AGE_GATE_APRIL_TEXT],
        },
        {
            value: AGE_GATE_CONSTS.MONTH_MAY_VALUE,
            text: localizedStrings[localizationKeys.AGE_GATE_MAY_TEXT],
        },
        {
            value: AGE_GATE_CONSTS.MONTH_JUNE_VALUE,
            text: localizedStrings[localizationKeys.AGE_GATE_JUNE_TEXT],
        },
        {
            value: AGE_GATE_CONSTS.MONTH_JULY_VALUE,
            text: localizedStrings[localizationKeys.AGE_GATE_JULY_TEXT],
        },
        {
            value: AGE_GATE_CONSTS.MONTH_AUGUST_VALUE,
            text: localizedStrings[localizationKeys.AGE_GATE_AUGUST_TEXT],
        },
        {
            value: AGE_GATE_CONSTS.MONTH_SEPTEMBER_VALUE,
            text: localizedStrings[localizationKeys.AGE_GATE_SEPTEMBER_TEXT],
        },
        {
            value: AGE_GATE_CONSTS.MONTH_OCTOBER_VALUE,
            text: localizedStrings[localizationKeys.AGE_GATE_OCTOBER_TEXT],
        },
        {
            value: AGE_GATE_CONSTS.MONTH_NOVEMBER_VALUE,
            text: localizedStrings[localizationKeys.AGE_GATE_NOVEMBER_TEXT],
        },
        {
            value: AGE_GATE_CONSTS.MONTH_DECEMBER_VALUE,
            text: localizedStrings[localizationKeys.AGE_GATE_DECEMBER_TEXT],
        },
    ];
};

const getYearsOptions = () => {
    const localizedStrings = getLocalizedStrings();
    const yearsArray = [
        {
            value: '',
            text: localizedStrings[localizationKeys.AGE_GATE_YEAR],
        },
    ];

    for (let i = new Date().getFullYear(); i >= AGE_GATE_CONSTS.YEAR_START_VALUE; i--) {
        yearsArray.push({
            value: i,
            text: i,
        });
    }

    return yearsArray;
};

const DEFAULT_MIN_YEARS = 18;
const DEFAULT_LOCK_TIME = 30;

const getMinAcceptedAge = () => appConfig.getAgeGateMinAge() || DEFAULT_MIN_YEARS;
const getAgeGateLockTime = () => appConfig.getAgeGateLockTime() || DEFAULT_LOCK_TIME;

const isAgeAcceptable = ({year, month}) => {
    const minAcceptedAge = getMinAcceptedAge();
    const date = new Date();
    const currentMonth = date.getMonth();
    const currentYear = date.getFullYear();
    const yearsDelta = currentYear - year;

    if (yearsDelta > minAcceptedAge) {
        return true;
    } else if (yearsDelta === minAcceptedAge) {
        return month <= currentMonth;
    } else {
        return false;
    }
};

const isAppLocked = () => {
    const ageGateLockedTs = storageService.getAgeGateLockedTsFromLocalStorage();

    if (ageGateLockedTs) {
        const timeDiff = new Date() - new Date(ageGateLockedTs);
        const isLocked = timeDiff < getAgeGateLockTime() * 60 * 1000;

        if (isLocked) {
            return true;
        } else {
            storageService.removeAgeGateLockedTsFromLocalStorage();
            return false;
        }
    }
};

const isAgeGateApproved = () => !!storageService.getAgeGateTsFromLocalStorage();

export default {
    isAgeAcceptable,
    getMonthsOptions,
    getYearsOptions,
    getMinAcceptedAge,
    getAgeGateLockTime,
    isAppLocked,
    isAgeGateApproved,
};
